import { omit } from 'lodash'
import { AnyObject } from '@feedyou/utils'
import { BotFeatures } from '@feedyou-ai/feedbot-schema'

export function removeConditionPropsFromSchema(schema: AnyObject, sdkFeatures: BotFeatures[]) {
  if (window.Cypress || sdkFeatures?.includes(BotFeatures.ALLOW_ALL_STEP_WITH_DISABLE_PROPERTY)) {
    return schema
  }

  return {
    ...schema,
    properties: omit(schema?.properties, ['disabled', 'condition', 'conditionTitle'])
  }
}
